/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module GearTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

/**
 * Fully-quantified path to file
 *
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "Path".
 */
export type Path = string;

export interface Gear {
    [k: string]: any;
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "PreviewOptions".
 */
export interface PreviewOptions {
    /**
     * If true, will store copies of non-processed and preprocessed regions to disk with each GEAR sampled frame.
     */
    dumpToDisk?: boolean;
    mediaType?: MediaType;
    /**
     * Period (in milliseconds) at which GEAR will sample a frame for the detectors
     */
    period?: number;
    /**
     * If true, shows the OCR translated data or the confidence level in the preview window with each processed frame.
     */
    showData?: boolean;
    /**
     * If true, shows a preview window of the sampled and preprocessed frames.  GEAR will process the configuration faster without the preview window shown
     */
    showPreview?: boolean;
    /**
     * If true, then if a GEAREvents.json is available in the directory with the GEAR configuration it will be used to generate an EDGE log.
     */
    generateEdgeLog?: boolean;
    /**
     * If true, will not return from call until preview operation is complete.  Otherwise returns immediately while GEAR analyzation thread runs.
     */
    wait?: boolean;
    /**
     * Sets the name of the application being previewed.  Normally this is set to the name of the game for which the GEAR configuraiton is being defined
     */
    appName?: string;
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "GetPreviewOutputInformationReturn".
 */
export interface GetPreviewOutputInformationReturn {
    /**
     * The complete path to the directory where the detector region images are stored (or were stored for the last preview operation)
     */
    dumpLocation: string;
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "StartParameters".
 */
export interface StartParameters {
    type: MediaType;
    app: string;
    pid: number;
    filename?: string;
    edgeLogFilename?: string;
    /**
     * If true, will store copies of non-processed and preprocessed regions to disk with each GEAR sampled frame.
     */
    dump?: boolean;
    /**
     * If true, shows a preview window of the sampled and preprocessed frames.  GEAR will process the configuration faster without the preview window shown
     */
    previewWindow?: boolean;
    frameCaptureMode?: FrameMode;
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "StartPreviewParameters".
 */
export interface StartPreviewParameters {
    /**
     * Fully qualified path to GEAR config file.  Other config locations are determined relative to config file.
     */
    config: string;
    /**
     * Fully qualified path to input video or image against which to apply the GEAR configuration
     */
    media: string;
    /**
     * Time (in milliseconds) within the media at which to begin the preview.  Ignored for static images.
     */
    start?: number;
    /**
     * Time (in milliseconds) within the media at which to stop the preview.  Value of -1 means the end of the media file.  Ignored for static images.
     */
    stop?: number;
    /**
     * Array of regionDef IDs
     */
    regions: string[];
    options?: PreviewOptions;
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "GetStatusReturn".
 */
export interface GetStatusReturn {
    /**
     * True if GEAR is enabled and the analyser is running
     */
    isAnalysing: boolean;
}

/**
 * The format of the input media.
 *
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "MediaType".
 */
export enum MediaType {
    auto_detect = 'auto_detect',
    nvfbc = 'nvfbc',
    video = 'video',
    image = 'image',
    kpi_test = 'kpi_test',
    manual = 'manual',
    filmstrip = 'filmstrip'
}
/**
 * This interface was referenced by `Gear`'s JSON-Schema
 * via the `definition` "FrameMode".
 */
export enum FrameMode {
    readToTarget = 'readToTarget',
    sleepToTarget = 'sleepToTarget',
    readOnlyTarget = 'readOnlyTarget'
}


}
